import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import classNames from 'classnames';

import {labels} from '../../../../../util/utils';
import {getContactsIds, getFlattenedContactsFromEntities, getUniqueContacts} from '../../../../../util/contactsDB';

import {selectContact} from '../../../../../actions/ContactDB/index';

import Checkbox from '../../../../CoreWrappers/Checkbox';

const SelectAll = () => {
	const uniqueContactsIds = useSelector(({contacts}) =>
		getContactsIds(getUniqueContacts(getFlattenedContactsFromEntities(contacts?.displayedEntities ?? [])))
	);
	const uniqueContactsCount = uniqueContactsIds.length;
	const selectedContactsCount = useSelector(({contacts}) => contacts?.selected?.length ?? 0);

	const dispatch = useDispatch();
	const selectAllContacts = () => dispatch(selectContact(uniqueContactsIds));
	const deselectAllContacts = () => dispatch(selectContact([]));

	const renderCheckbox = () => {
		const checked = selectedContactsCount === uniqueContactsCount;
		const indeterminate = selectedContactsCount !== uniqueContactsCount;

		const props = {
			id: `select-all`,
			checked,
			indeterminate,
			value: checked,
			label: indeterminate ? labels.selectAll : labels.deselectAll,
			className: classNames({['partialChecked']: indeterminate}),
			onChange: indeterminate ? selectAllContacts : deselectAllContacts
		};

		return <Checkbox {...props} />;
	};

	return renderCheckbox();
};

export default SelectAll;
